import React from 'react'
import './error-popup.css'

export const ErrorPopup = (props) => {
    return( 
        <div className="ErrorPopup">
            <div className="error-popup-content">
                <div className='error-popup-body__red-line'></div>
                <div className="error-popup-body">
                    {props.error.message ? <div className='error-popup-body__title'>Error {props.error.status}!</div> : <div className='error-popup-body__title'>Error</div>}
                    <div className='error-popup-gif'></div>
                    {props.error.message ? <div className='error-popup-body__message'>{props.error.message}</div> : <div className='error-popup-body__message'>Unknown Error: Refresh and try again. If error persists email Prescott.</div>}
                </div>
                <div className="error-popup-btn" onClick={() => props.setError(false)}>Close</div>
            </div>
        </div>
    )
}